import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Btn from '../../../components/Btn';
import '../../../grid.css';


class PPA extends Component {
    static propTypes = {
        ppaRate: PropTypes.number.isRequired,
        ppaTerm: PropTypes.number.isRequired,
        isVisible: PropTypes.bool.isRequired,
        ppaEscalator: PropTypes.number.isRequired,
        isLocked: PropTypes.bool.isRequired,
        setPpaIsVisible: PropTypes.func.isRequired,
        setPPARate: PropTypes.func.isRequired,
        setPPATerm: PropTypes.func.isRequired,
        setPPAEscalator: PropTypes.func.isRequired,
        setShowPPA: PropTypes.func.isRequired,
        showPPA: PropTypes.bool.isRequired,
        resiToggle: PropTypes.bool.isRequired,
        setSelectedFinancing: PropTypes.func.isRequired,
    };

    togglePPATerms() {
        const { setPpaIsVisible, isVisible } = this.props;
        setPpaIsVisible(!isVisible);
    }

    handlePPARateChange(value) {
        const { setPPARate } = this.props;
        setPPARate(Number(value));
    }

    handlePPATermChange(value) {
        const { setPPATerm } = this.props;
        setPPATerm(parseInt(value, 10));
    }

    handlePPAEscalatorChange(value) {
        const { setPPAEscalator } = this.props;
        setPPAEscalator(Number(value));
    }

    handleShowPPAToggle() {
        const { setShowPPA, showPPA, setSelectedFinancing } = this.props;
        setShowPPA(!showPPA);
        if (showPPA) {
            setSelectedFinancing(4);
        }
        if (!showPPA) {
            setSelectedFinancing(1);
        }
    }

    render() {
        const {
            ppaRate, ppaTerm, ppaEscalator, isVisible, isLocked, showPPA, resiToggle,
        } = this.props;
        let isDisabled = isLocked;
        if (resiToggle === true || isLocked === true) {
            isDisabled = true;
        }
        return (
            <div>
                <Btn
                    label="PPA"
                    onClick={(e, value) => this.togglePPATerms(value)}
                />
                {isVisible ? (
                    <div>
                        <div className="col span-1-of-4 checkboxes">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={isDisabled}
                                        onChange={(e, value) => this.handleShowPPAToggle(value)}
                                        checked={showPPA}
                                    />
                                }
                                label="Include PPA"
                            />
                        </div>
                        {showPPA ? (
                            <div>
                                <div className="col span-1-of-4">
                                    <TextField
                                        defaultValue={ppaRate}
                                        onChange={(e, value) => this.handlePPARateChange(value)}
                                        hintText="0.085"
                                        floatingLabelText="PPA Rate"
                                        disabled={isDisabled}
                                    />
                                </div>
                                <div className="col span-1-of-4">
                                    <TextField
                                        hintText="1.9"
                                        defaultValue={ppaEscalator}
                                        onChange={(e, value) =>
                                            this.handlePPAEscalatorChange(value)}
                                        floatingLabelText="PPA Escalator (%)"
                                        disabled={isDisabled}
                                    />
                                </div>
                                <div className="col span-1-of-4">
                                    <TextField
                                        hintText="20"
                                        defaultValue={ppaTerm}
                                        onChange={(e, value) => this.handlePPATermChange(value)}
                                        floatingLabelText="PPA Term Length (years)"
                                        disabled={isDisabled}
                                    />
                                </div>
                            </div>
                        ) : null }
                    </div>
                ) : null}
            </div>
        );
    }
}

export default PPA;



// WEBPACK FOOTER //
// ./src/containers/Inputs/PPA/PPA.js